import React, { useState } from 'react';
import moment from 'moment';

import { Stack, TaskCard, Text } from 'shell/components';

const ACTION_OPTIONS = [
    { key: 'edit', value: 'Edit' },
    { key: 'duplicate', value: 'Duplicate' },
    { key: 'delete', value: 'Delete' },
];

const COLLABORATOR_OPTIONS = [
    {
        id: '1',
        owner_account_id: '1',
        first_name: 'Jennie',
        last_name: 'Watson',
        email: 'jennie.watson@example.com',
    },
    {
        id: '2',
        owner_account_id: '2',
        first_name: 'Louisa',
        last_name: 'Kirk',
        email: 'louisa.kirk@example.com',
    },
    {
        id: '3',
        owner_account_id: '3',
        first_name: 'Quilin',
        last_name: 'Yang',
        email: 'quilin.yang@example.com',
    },
];

const getNameById = (targetId) => {
    const { first_name, last_name } = COLLABORATOR_OPTIONS.find(
        ({ owner_account_id }) => owner_account_id === targetId
    );
    return `${first_name} ${last_name}`;
};

const getUserById = (targetId) => {
    return COLLABORATOR_OPTIONS.find(({ owner_account_id }) => owner_account_id === targetId);
};

const TaskCardDemo = () => {
    const [tasks, setTasks] = useState([
        {
            id: '1',
            status: 'toDo',
            title: 'Task Name',
            end_on: moment().valueOf(),
            workload: 'low',
            collaborator_account_ids: [],
            subtasks: [],
        },
        {
            id: '2',
            status: 'toDo',
            title: 'Task Name',
            end_on: moment().subtract(1, 'day').valueOf(),
            workload: 'low',
            collaborator_account_ids: [],
            subtasks: [],
        },
        {
            id: '3',
            status: 'toDo',
            title: 'Milestone Name',
            end_on: moment().valueOf(),
            workload: 'low',
            collaborator_account_ids: [],
            subtasks: [],
        },
        {
            id: '4',
            status: 'toDo',
            title: 'Milestone Name',
            end_on: moment().subtract(1, 'day').valueOf(),
            workload: 'low',
            collaborator_account_ids: [],
            subtasks: [],
        },
    ]);

    const handleClickComplete = (taskId) => {
        setTasks((current) => {
            return current.map((currentTask) => {
                if (currentTask.id !== taskId) return currentTask;
                return {
                    ...currentTask,
                    status: currentTask.status !== 'completed' ? 'completed' : 'toDo',
                };
            });
        });
    };

    const handleChangeCollaborator = (taskId, accountUser) => {
        setTasks((current) => {
            return current.map((currentTask) => {
                if (currentTask.id !== taskId) return currentTask;
                const newCollaborators = currentTask.collaborator_account_ids.includes(accountUser.owner_account_id)
                    ? currentTask.collaborator_account_ids.filter(
                          ({ owner_account_id }) => owner_account_id !== accountUser.owner_account_id
                      )
                    : [...currentTask.collaborator_account_ids, accountUser.owner_account_id];
                return {
                    ...currentTask,
                    collaborator_account_ids: newCollaborators,
                };
            });
        });
    };

    return (
        <>
            <Text variant={'sh1'}>TaskCard</Text>
            <Stack sx={{ width: '308px' }} spacing={2}>
                <TaskCard task={tasks[0]} getUserById={getUserById} variant={'simplified'} />
                <TaskCard task={tasks[1]} getUserById={getUserById} variant={'simplified'} />
                <TaskCard
                    task={tasks[0]}
                    getNameById={getNameById}
                    getUserById={getUserById}
                    actionOptions={ACTION_OPTIONS}
                    collaboratorOptions={COLLABORATOR_OPTIONS}
                    onChangeCollaborator={(taskId, accountUser) => handleChangeCollaborator(taskId, accountUser)}
                    onClick={() => {}}
                    onClickComplete={(taskId) => handleClickComplete(taskId)}
                    onSelectAction={() => {}}
                />
                <TaskCard
                    task={tasks[1]}
                    getNameById={getNameById}
                    getUserById={getUserById}
                    actionOptions={ACTION_OPTIONS}
                    collaboratorOptions={COLLABORATOR_OPTIONS}
                    onChangeCollaborator={(taskId, accountUser) => handleChangeCollaborator(taskId, accountUser)}
                    onClick={() => {}}
                    onClickComplete={(taskId) => handleClickComplete(taskId)}
                    onSelectAction={() => {}}
                />
                <TaskCard
                    task={tasks[2]}
                    variant={'milestone'}
                    getNameById={getNameById}
                    getUserById={getUserById}
                    actionOptions={ACTION_OPTIONS}
                    collaboratorOptions={COLLABORATOR_OPTIONS}
                    onChangeCollaborator={(taskId, accountUser) => handleChangeCollaborator(taskId, accountUser)}
                    onClick={() => {}}
                    onClickComplete={(taskId) => handleClickComplete(taskId)}
                    onSelectAction={() => {}}
                />
                <TaskCard
                    task={tasks[3]}
                    variant={'milestone'}
                    getNameById={getNameById}
                    getUserById={getUserById}
                    actionOptions={ACTION_OPTIONS}
                    collaboratorOptions={COLLABORATOR_OPTIONS}
                    onChangeCollaborator={(taskId, accountUser) => handleChangeCollaborator(taskId, accountUser)}
                    onClick={() => {}}
                    onClickComplete={(taskId) => handleClickComplete(taskId)}
                    onSelectAction={() => {}}
                />
            </Stack>
        </>
    );
};

export default TaskCardDemo;
